import React, {
    Fragment,
    FunctionComponent,
    ReactElement,
} from 'react';

import { IMaybeParentProps } from '../../shared/types/IMaybeParentProps';
import { IParentProps } from '../../shared/types/IParentProps';

export type ILayoutSlot<TType> = FunctionComponent & {
    ozSlot: TType;
};

export function createLayoutSlot<TSlot, TProps> (
    slotType: TSlot,
    displayName: string,
    component: FunctionComponent<TProps>
): FunctionComponent<IMaybeParentProps>;
export function createLayoutSlot<TSlot> (
    slotType: TSlot,
    displayName: string
): FunctionComponent<IMaybeParentProps>;

export function createLayoutSlot<TSlot> (...args: any[]): FunctionComponent<IMaybeParentProps> {
    const slotType: TSlot = args[0];
    const displayName: string = args[1];

    const Slot: ILayoutSlot<TSlot> =
        args[2] ||
        ((props: IParentProps): ReactElement => {
            const { children }: IParentProps = props;

            return <Fragment>{children}</Fragment>;
        });

    Slot.ozSlot = slotType;
    Slot.displayName = displayName;

    return Slot;
}
